import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

const PageLoading = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default PageLoading;
